export default import.meta.ROLLDOWN_FILE_URL_3z89KvtimqkT_J0Jmj85iA